import Text from "common/Typography/Text";
import React from "react";
import styled from "styled-components";
import Flex from "common/Boxes/Flex";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import Link from "common/Typography/Link";
import Title from "common/Typography/Title";

interface MyGroupsMessageProps {
  icon: React.JSX.Element;
  title: string;
  description: string | React.JSX.Element;
  linkText?: string;
  onLinkClick?: () => void;
  isHorizontal?: boolean;
}

const MyGroupsMessage = ({
  icon,
  title,
  description,
  linkText,
  onLinkClick,
  isHorizontal,
}: MyGroupsMessageProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <Wrapper $isHorizontal={isHorizontal}>
      {icon}
      <TextWrapper $isHorizontal={isHorizontal}>
        <Title level={3} style={{ marginBottom: isMobile ? 0 : 4 }}>
          {title}
        </Title>
        <Text type="secondary">{description}</Text>
        {!isMobile && linkText && (
          <Link style={{ marginTop: 4 }} onClick={onLinkClick}>
            {linkText}
          </Link>
        )}
      </TextWrapper>
    </Wrapper>
  );
};

export default MyGroupsMessage;

const Wrapper = styled(Flex)<{ $isHorizontal?: boolean }>`
  transform: translateY(-16px);
  flex-direction: ${(p) => (p.$isHorizontal ? "row" : "column")};
  justify-content: center;
`;
const TextWrapper = styled(Flex)<{ $isHorizontal?: boolean }>`
  flex-direction: column;
  align-items: ${(p) => (p.$isHorizontal ? "start" : "center")};
  text-align: ${(p) => (p.$isHorizontal ? "start" : "center")};
  ${(p) =>
    p.$isHorizontal &&
    `
  margin: 16px 0 0 16px;
  `}
`;
